import LocationObject from 'entities/locationObject/model';
import { US_UNINCORPORATED_TERRITORIES } from 'utils/addressToLocation';
import { map } from 'utils/countries';
import { USStates } from 'utils/USStates';
import { AddressValidationError } from 'utils/AddressValidationError';

import { GoogleAddressAPIResponse } from './types';

export const mapResponse = (
  response: GoogleAddressAPIResponse,
  countryCode: string
): LocationObject => {
  if (!('result' in response)) {
    throw new AddressValidationError(
      "There's been an error trying to verify the address, please try again"
    );
  }
  const { latitude, longitude } = response.result?.geocode.location;
  const { addressLines, locality, postalCode, administrativeArea } =
    response.result?.address?.postalAddress || {};

  const [address, ...restAddress] = addressLines || [];

  const isUSTerritory = US_UNINCORPORATED_TERRITORIES.includes(countryCode);
  const effectiveCountryCode = isUSTerritory ? 'US' : countryCode;
  const effectiveStateCode = (isUSTerritory ? countryCode : administrativeArea) || '';
  const stateName = USStates[effectiveStateCode as keyof typeof USStates];

  const country = map[countryCode];

  return new LocationObject({
    manualEntry: true,
    address,
    address2: restAddress?.join(', '),
    city: locality,
    postalCode,
    state: stateName,
    stateCode: effectiveStateCode,
    country: country?.name,
    countryCode: effectiveCountryCode,
    geo: {
      type: 'Point',
      coordinates: [longitude, latitude],
    },
  });
};
